import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/colors_and_type.css';
import './styles/styles.css';
import App from './App.jsx';
import { ToastProvider } from './components/Toast.jsx';

createRoot(document.getElementById('root')).render(
  <ToastProvider>
    <App />
  </ToastProvider>,
);
